import { privateInstance } from "../configs";

export const expenseApi = {
  async getExpenses() {
    const res = await privateInstance.get("/invoices/api/expenses/cl/");
    return res.data;
  },
  async retrieveExpense(id) {
    const res = await privateInstance.get(`/invoices/api/expenses/rud/${id}/`);
    return res.data;
  },
  async postExpense(expense) {
    const res = await privateInstance.post(
      "/invoices/api/expenses/cl/",
      expense
    );
    return res.data;
  },
  async putExpense(id, expense) {
    const res = await privateInstance.put(
      `/invoices/api/expenses/rud/${id}/`,
      expense
    );
    return res.data;
  },
  async deleteExpense(id) {
    await privateInstance.delete(`/invoices/api/expenses/rud/${id}/`);
  }
};
